import { IPlayerState } from "State/Player/IPlayerState";
import DateHelper, { getSQLDate } from "./DateHelper";
import { SEASON_PASS_DURATION, INITIAL_SEASON_PASS_DATE } from "Constants/SeasonPass";

export function getSeasonPassStartDate(date?: Date): Date {
    const now = date || DateHelper.now;
    if (now < INITIAL_SEASON_PASS_DATE) {
        return INITIAL_SEASON_PASS_DATE;
    }

    const elapsed = now.getTime() - INITIAL_SEASON_PASS_DATE.getTime();
    const cycles = Math.floor(elapsed / SEASON_PASS_DURATION);
    return new Date(INITIAL_SEASON_PASS_DATE.getTime() + cycles * SEASON_PASS_DURATION);
}

export function getSeasonPassEndDate(date?: Date): Date {
    return DateHelper.getDate(getSeasonPassStartDate(date).getTime() + SEASON_PASS_DURATION - 1000);
}

export function getNextSeasonPassStartDate(date?: Date): Date {
    return DateHelper.getDate(getSeasonPassStartDate(date).getTime() + SEASON_PASS_DURATION);
}

export function isSeasonPassPremiumBought(playerState: IPlayerState): boolean {
    return !!playerState.seasonPass?.boughtPremiumPass;
}

export function getSeasonPassSeed(date?: Date): string {
    return getSQLDate(getSeasonPassStartDate(date));
}